<template>
    <span class="label"
          :class="labelClass">{{ l(statusLangKey) }}</span>
</template>

<script>
import { getPaymentStatusLangKey } from '@/lib/Payments/paymentHelperFunctions';

export default {
    props: {
        /**
         * @type {Payment}
         */
        payment: {
            type: Object,
            required: true,
        },
    },

    computed: {
        statusLangKey() {
            return getPaymentStatusLangKey(this.payment);
        },

        labelClass() {
            switch (this.statusLangKey) {
                case 'PAYMENT_STATUS.FAILED':
                    return 'label-danger';
                case 'PAYMENT_STATUS.PAID':
                    return 'label-success';
                case 'PAYMENT_STATUS.PENDING':
                    return 'label-warning';
            }

            return 'label-default';
        },
    },
};
</script>
